export default "__VITE_ASSET__Bbz2vL3w__"